import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import app from 'flarum/forum/app';
export default class FeedbackStats extends Component {
  view() {
    const {
      stats,
      loading
    } = this.attrs;
    if (loading) {
      return m("div", {
        className: "TraderFeedbackPage-stats"
      }, m(LoadingIndicator, {
        size: "small"
      }));
    }
    if (!stats) {
      return m("div", {
        className: "TraderFeedbackPage-stats TraderFeedbackPage-stats--empty"
      });
    }
    const total = stats.positive_count + stats.neutral_count + stats.negative_count;
    const scorePercentage = total > 0 ? Math.round(stats.score) : 0;
    return m("div", {
      className: "TraderFeedbackPage-stats"
    }, m("div", {
      className: "TraderFeedbackPage-stat TraderFeedbackPage-stat--score"
    }, m("div", {
      className: "TraderFeedbackPage-stat-value"
    }, scorePercentage, "%"), m("div", {
      className: "TraderFeedbackPage-stat-label"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.stats.score'))), m("div", {
      className: "TraderFeedbackPage-stat TraderFeedbackPage-stat--positive"
    }, m("div", {
      className: "TraderFeedbackPage-stat-value"
    }, stats.positive_count), m("div", {
      className: "TraderFeedbackPage-stat-label"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.stats.positive'))), m("div", {
      className: "TraderFeedbackPage-stat TraderFeedbackPage-stat--neutral"
    }, m("div", {
      className: "TraderFeedbackPage-stat-value"
    }, stats.neutral_count), m("div", {
      className: "TraderFeedbackPage-stat-label"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.stats.neutral'))), m("div", {
      className: "TraderFeedbackPage-stat TraderFeedbackPage-stat--negative"
    }, m("div", {
      className: "TraderFeedbackPage-stat-value"
    }, stats.negative_count), m("div", {
      className: "TraderFeedbackPage-stat-label"
    }, app.translator.trans('huseyinfiliz-traderfeedback.forum.feedback_page.stats.negative'))));
  }
}
flarum.reg.add('huseyinfiliz-traderfeedback', 'forum/components/TraderFeedback/FeedbackStats', FeedbackStats);